export default "__VITE_ASSET__AGAq_4HD__"